const MISCELLANEOUS = {
    pageDataAid: "orderPreferences",
    pageTitle: {
        text:'Order preferences',
        dataAid: 'orderPreferences'
    },
    subtitle: {
        text: 'Set default order type for Stocks and F&O',
        dataAid: 'subtitle'
    },
    footerBtn: {
        text: 'Save',
        dataAid: 'primary'
    },
    orderTypeRow: {
        label: {
            text: 'Order type',
            dataAid: 'orderType'
        },
        control: {
            toggleDataAid: "orderType",
        },
    },
    protectionLimitRow: {
        label: {
            text: 'Enter protection %',
            dataAid: 'enterProtection'
        },
        control: {
            minusIconDataAid: 'subtract',
            plusIconDataAid: 'add',
            inputDataAid: "setLimit",
        },
        infoTooltip: {
            text: 'Specify a limit while buying or selling shares to have more control over market volatility',
            dataAid: 'specifyLimit'
        },
        infoIconDataAid: "info"
    },
    updateSuccessMsg: {
        text: "Preference saved"
    }
}

const TABS = {
    cashTab: {
        text: 'Cash',
        dataAid: '1'
    },    
    fnOTab: {
        text: 'F&O',
        dataAid: '2'
    },
}

const CASH_TAB = {
    orderTypeRow: {
        leftOption: { text: "Delivery", dataAid: "delivery" },
        rightOption: { text: "Intraday", dataAid: "intraday" }
    },
    nseCash: {
        title: {
            text: 'NSE cash',
            dataAid: 'title',
        },
        cardDataAid: 'nseCash',
    },
    bseCash: {
        title: {
            text: 'BSE cash',
            dataAid:'title'
        },
        cardDataAid: 'bseCash',
    },
}

const FNO_TAB = {
    orderTypeRow: {
        leftOption: { text: "Carryforward", dataAid: "delivery" },
        rightOption: { text: "Intraday", dataAid: "intraday" }
    },
    nseDerivatives: {
        title: {
            text: 'NSE derivatives',
            dataAid: 'title',
        },
        cardDataAid: 'nseDerivatives',
    },
    nseCds: {
        title: {
            text: 'NSECDS',
            dataAid: 'title'
        },
        cardDataAid: 'nsecds',
    },
    nseOts: {
        title: {
            text: 'NSE-OTS',
            dataAid: 'title'
        },
        cardDataAid: 'nseOts',
    }
}



const ORDER_PREFERENCE = {
    ...MISCELLANEOUS,
    TABS,
    CASH_TAB,
    FNO_TAB
}

export default ORDER_PREFERENCE
